import React from 'react'


const PasswordSent = ({
    hasError,
    onTryAgain
}) => (
    <div className={'jm-pwd-sent' + (hasError ? ' has-error' : '')}>
        <div className="jm-content-light jm-editor-text">
            {hasError ? (
                <p>Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.</p>
            ) : (
                <>
                    <p>Falls Ihre E-Mail-Adresse einem User zugeordnet ist, haben Sie eine E-Mail zum Erstellen Ihres Passwortes erhalten.</p>
                    <p className="jm-editor-blankline">Bitte überprüfen Sie auch Ihren Spam-Ordner.</p>
                    <p>Sollten Sie keine Mail erhalten haben, wenden Sie sich bitte bei <a href="mailto:talia@job4u-ev.de">talia@job4u-ev.de</a>, damit wir das Problem schnell lösen können.</p>
                </>
            )}
        </div>
        
        {hasError && <button 
            className="jm-action-button jm-arrow-right"
            onClick={onTryAgain}
        >
            Erneut probieren
        </button>}
    </div>
)

export default PasswordSent